import React from 'react';
import PropTypes from 'prop-types';
import styles from './ViewSettingsPanel.module.scss';
import { useLanguage } from '@/localization/useLanguage';

export default function ViewSettingsPanel({
   open,
   onClose,
   viewMode,
   setViewMode,
   maxTiles,
   setMaxTiles,
   hideNoVideo,
   setHideNoVideo,
}) {
   const { t } = useLanguage();
   if (!open) return null;
   const disbaleMode = ['spotlight', 'sidebar'].includes(viewMode);

   return (
      <div className={`${styles.overlay} ct-flexCenter`}>
         <button className={styles.backdrop} onClick={onClose} aria-label={t('common.DONE')} type="button" />
         <div className={styles.panel}>
            <div className={`${styles.header} ct-flex ct-aiCenter ct-jcBetween`}>
               <h3>{t('common.ADJUST_VIEW')}</h3>
               <button onClick={onClose} className={`${styles.close} ct-flexCenter`}>
                  ✕
               </button>
            </div>

            <div className={styles.section}>
               {[
                  { id: 'cts-view-audio', value: 'auto', label: 'common.VIEW_AUTO' },
                  { id: 'cts-tiled', value: 'tiled', label: 'common.VIEW_TILED' },
                  { id: 'cts-view-spotlight', value: 'spotlight', label: 'common.VIEW_SPOTLIGHT' },
                  { id: 'cts-view-sidebar', value: 'sidebar', label: 'common.VIEW_SIDEBAR' },
               ].map(mode => (
                  <label key={mode.value} className={`${mode.id} ${styles.radio} ct-flexAlign`}>
                     <input
                        type="radio"
                        name="view"
                        checked={viewMode === mode.value}
                        onChange={() => setViewMode(mode.value)}
                     />{' '}
                     {t(mode.label)}
                  </label>
               ))}
            </div>

            <div className={styles.section}>
               <label htmlFor="tile-range" className={styles.label}>
                  {t('common.TILES_MAX')}
               </label>
               {(() => {
                  const allowed = [6, 12, 25, 30, 35, 40];
                  // Find closest index
                  const currentIndex = allowed.findIndex(v => v === maxTiles);
                  const valIndex = currentIndex === -1 ? 0 : currentIndex;

                  return (
                     <>
                        <input
                           id="tile-range"
                           type="range"
                           min="0"
                           disabled={disbaleMode}
                           max={allowed.length - 1}
                           step="1"
                           value={valIndex}
                           list="tile-markers"
                           onChange={e => setMaxTiles(allowed[Number(e.target.value)])}
                           className={styles.slider}
                        />
                        <datalist id="tile-markers">
                           {allowed.map((val, idx) => (
                              <option key={`tile-${val}`} value={idx}></option>
                           ))}
                        </datalist>
                     </>
                  );
               })()}
               <div className={styles.sliderValue}>{maxTiles}</div>
            </div>

            <div className={styles.section}>
               <label className={`${styles.switch} ct-flexAlign`}>
                  <input type="checkbox" checked={hideNoVideo} onChange={e => setHideNoVideo(e.target.checked)} />{' '}
                  {t('common.HIDE_NO_VIDEO')}
               </label>
            </div>

            <div className={`${styles.footer} ct-flex ct-jcEnd`}>
               <button onClick={onClose} className={styles.done}>
                  {t('common.DONE')}
               </button>
            </div>
         </div>
      </div>
   );
}

ViewSettingsPanel.propTypes = {
   open: PropTypes.bool.isRequired,
   onClose: PropTypes.func.isRequired,
   viewMode: PropTypes.string.isRequired,
   setViewMode: PropTypes.func.isRequired,
   maxTiles: PropTypes.number.isRequired,
   setMaxTiles: PropTypes.func.isRequired,
   hideNoVideo: PropTypes.bool.isRequired,
   setHideNoVideo: PropTypes.func.isRequired,
};
